export default __webpack_public_path__ + "static/media/packpurchase.e92956ee.svg";